
import { z } from 'zod';

export const skillInventoryItemSchema = z.object({
    skillName: z.string().min(1, "Skill name is required"),
    checkbox1: z.boolean().optional(), // Not used in UI but backend expects it, will default false
    checkbox2: z.boolean().optional(),
    checkbox3: z.boolean().optional(),
    feelConfident: z.boolean().optional(),
    needTraining: z.boolean().optional(),
    nA: z.boolean().optional(),
    comments: z.string().optional().nullable()
});

export const skillInventorySchema = z.object({
    tenantId: z.coerce.number().positive(),
    userId: z.coerce.number().positive().optional(),
    applicantName: z.string().regex(/^[^0-9]*$/, "Name cannot contain digits").optional().nullable(),
    employeeName: z.string().regex(/^[^0-9]*$/, "Name cannot contain digits").optional().nullable(),
    applicantSignature: z.string().optional().nullable(),
    applicantSignedBy: z.string().optional().nullable(),
    applicantSignedAt: z.string().optional().nullable(),
    reviewedBySignature: z.string().optional().nullable(),
    reviewedBySignedAt: z.string().optional().nullable(),
    applicantSignatureDate: z.string().optional().nullable(),
    applicantStatementAccepted: z.boolean().refine(val => val === true, {
        message: "You must verify that you have completed the Skill Inventory accurately."
    }),
    items: z.array(skillInventoryItemSchema).optional()
});
